import { render } from "./Loader.vue?vue&type=template&id=f7c8b686&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=f7c8b686&scoped=true&lang=scss"

import exportComponent from "/builds/common/delivery-front/dev-factory/supplyweb/opticam/packages/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7c8b686"]])

export default __exports__